/**
 * @link https://documenter.getpostman.com/view/4774204/SVtPZXKk?version=latest
 */
export const Endpoints = {
    login: 'oauth/token',
    logout: 'user/logout',
    self: 'user/self',

    utility_upload: 'utility/upload',
    change_password: 'user/changePassword',
    allowed_promotion_type_list: 'allowedPromotionType/list',
    allowed_promotion_type_save: 'allowedPromotionType/add',
    notification_list: 'systemNotification/list',
    set_user_role_team: 'userRole/manageTeam',


    /** Dashboard Menu Starts*/

    dashboard_role_wise_presence_count: 'attendance/roleWisePresenceCount',
    dashboard_market_wise_pending_count: 'attendance/marketWisePendingCount',
    dashboard_market_wise_presence_count: 'attendance/marketWisePresenceCount',
    dashboard_market_role_shift_wise_presence_count: 'attendance/marketRoleShiftWisePresenceCount',
    dashboard_total_prescription_count: 'prescription/count',
    dashboard_market_wise_prescription_count: 'prescription/marketWiseCount',
    dashboard_total_dcr_count: 'doctorVisit/count',
    dashboard_total_submitted_by_dcr_count: 'doctorVisit/count/submittedBy',
    dashboard_market_wise_dcr_count: 'doctorVisit/marketWiseCount',
    dashboard_visited_doctor_count: 'doctorVisit/visitedDoctorCountByPlan',
    dashboard_planned_doctor_count: 'doctorVisitPlan/doctorCount',
    dashboard_market_wise_visited_doctor_count: 'doctorVisit/marketWiseVisitedDoctorCountByPlan',
    dashboard_market_wise_planned_doctor_count: 'doctorVisitPlan/marketWiseDoctorCount',
    dashboard_market_wise_doctor_count: 'doctor/marketWiseCount',
    dashboard_market_wise_total_doctor_count: 'doctorVisit/marketWiseDoctorCount',
    dashboard_submitted_dcr_by_user: 'doctorVisit/marketWiseUserCount',
    dashboard_submitted_rx_by_user: 'prescription/marketWiseUserCount',
    dashboard_total_rx_count: 'prescription/count',
    dashboard_market_wise_rx_count: 'prescription/marketWiseCount',
    dashboard_rx_captured_count: 'dashboard/getRxCapturedByCount',
    dashboard_focus_brand_wise_count: 'prescription/focusBrandWiseCount',
    dashboard_date_wise_focus_brand_count: 'prescription/focusBrandDateWiseCount',
    dashboard_brands_in_rx: 'dashboard/brandRxCount',
    dashboard_order_count: 'dashboard/dayWiseOrderSummary',
    dashboard_day_wise_user_dcr_count: 'dashboard/dayWiseDcrUserCount',
    dashboard_todays_rx_count: 'dashboard/todaysRxCountOfMarket',
    dashboard_brandwise_order_count: 'dashboard/brandWiseOrderAmount',
    dashboard_todays_rx_captured: 'dashboard/viewTodaysCapturedByCount',
    dashboard_todays_brand_in_rx_count: 'dashboard/todaysBrandInRxCount',
    dashboard_chemist_coverage_count: 'dashboard/marketWiseChemistVisitCount',
    daily_doctor_order_count: 'dashboard/dailyDoctorOrder',
    market_target_count: 'dashboard/marketSalesTarget',
    brand_dcr_count: 'dashboard/brandDcrCount',
    brand_rx_count: 'dashboard/brandRxCount',
    dashboard_dcr_count: 'dashboard/dayWiseDcrCount',
    dashboard_rx_count: 'dashboard/dayWiseRxCount',
    dashboard_chemist_visit_count: 'dashboard/dayWiseChemistVisitCount',
    dashboard_attendance_count: 'dashboard/dayWiseAttendanceCount',
    dashboard_order_amount: 'dashboard/marketWiseAmount',
    dashboard_key_value: 'keyValue/',
    dashboard_key_value_manage: 'keyValue',
    dashboard_market_and_role_wise_presence_absent_count: 'attendance/marketRoleWisePresenceCount',


    /** Dashboard Menu Ends*/

    /** Chemist Menu Starts*/

    // chemist list
    export_chemist_list: 'chemist/export',
    chemist_list: 'chemist/list',
    chemist_details: 'chemist',
    chemist_add: 'chemist/add',
    chemist_edit: 'chemist/edit',
    chemist_approve: 'chemist/approve',
    chemist_booked_amount: 'api/v1/bookedAmount/chemist',
    chemist_location_delete: 'chemist/location/delete',
    chemist_return_balance: 'chemist/v1/return-balance',
    chemist_balance: 'chemist/v1/balance',
    update_chemist_credit_limit: 'chemist/update-chemist-credit-limit',
    chemist_list_for_mpo_wise_payment: 'api/v1/payment-collection/mpo-wise-payment/chemist-list',
    chemist_list_v2: 'api/v1/chemist/list',
    chemist_details_v2: 'api/v1/chemist/details',
    chemist_approve_v2: 'api/v1/chemist/approve',
    chemist_bulk_approve_v2: 'api/v1/chemist/approve/bulk',
    chemist_waiting_for_approval_v2: 'api/v1/chemist/list/waiting-for-approval',

    // chemist settings
    chemist_type_list: 'chemistType/list',
    chemist_type_details: 'chemistType',
    chemist_type_add: 'chemistType/add',
    chemist_type_edit: 'chemistType/edit',

    /** Chemist Menu Ends*/

    /** Doctor & Institute Menu Starts*/

    // doctor list
    doctor_list: 'doctor/list',
    export_doctor_list: 'doctor/list',
    doctor_details: 'doctor',
    doctor_add: 'doctor/add',
    doctor_edit: 'doctor/edit',
    doctor_approve: 'doctor/approve',
    doctor_expected_product_add: 'doctorExpectedProduct/add',
    doctor_expected_product_edit: 'doctorExpectedProduct/edit',
    doctor_expected_product_delete: 'doctorExpectedProduct',
    update_expected_product: 'doctor/updateExpectedProduct',
    expected_product_list_by_doctor: 'doctorExpectedProduct/listByDoctor',
    doctor_list_by_ids: 'doctor/list-by-ids',
    doctor_list_of_mpo: 'doctor/list-for-filter',
    doctor_all_list_for_filter: 'doctor/all-list-for-filter',

    // doctor settings
    degree_list: 'academicDegree/list',
    degree_details: 'academicDegree',
    degree_add: 'academicDegree/add',
    degree_edit: 'academicDegree/edit',

    doctor_designation_list: 'doctorDesignation/list',
    doctor_designation_details: 'doctorDesignation',
    doctor_designation_add: 'doctorDesignation/add',
    doctor_designation_edit: 'doctorDesignation/edit',

    doctor_category_list: 'doctorCategory/list',
    doctor_category_details: 'doctorCategory',
    doctor_category_add: 'doctorCategory/add',
    doctor_category_edit: 'doctorCategory/edit',

    doctor_image_type_list: 'doctorImageType/list',
    doctor_image_type_details: 'doctorImageType',
    doctor_image_type_add: 'doctorImageType/add',
    doctor_image_type_edit: 'doctorImageType/edit',

    speciality_list: 'speciality/list',
    speciality_details: 'speciality',
    speciality_add: 'speciality/add',
    speciality_edit: 'speciality/edit',

    sub_speciality_list: 'subSpeciality/list',
    sub_speciality_add: 'subSpeciality/add',
    sub_speciality_edit: 'subSpeciality/edit',

    chamber_type_details: 'chamberType',
    chamber_type_add: 'chamberType/add',
    chamber_type_edit: 'chamberType/edit',
    chamber_type_list: 'chamberType/list',

    patient_type_list: 'patientType/list',
    patient_type_details: 'patientType',
    patient_type_add: 'patientType/add',
    patient_type_edit: 'patientType/edit',

    special_day_list: 'specialDay/list',
    special_day_details: 'specialDay',
    special_day_add: 'specialDay/add',
    special_day_edit: 'specialDay/edit',

    // survey doctor
    survey_doctor_list: 'doctor/surveyDoctorList',
    survey_doctor_edit: 'doctor/editSurveyDoctor',
    create_doctor_from_survey_doctor: 'doctor/createDoctorFromSurveyDoctor',

    // doctor record
    doctor_record_list: 'doctorRecord/list',
    doctor_record_edit: 'doctorRecord/edit',
    doctor_record_add: 'doctorRecord/add',
    doctor_record_details: 'doctorRecord',
    doctor_record_upload: 'doctorRecord/upload',

    // institute
    institute_type_list: 'instituteType/list',
    institute_type_details: 'instituteType',
    institute_type_add: 'instituteType/add',
    institute_type_edit: 'instituteType/edit',

    institute_list: 'institute/list',
    institute_details: 'institute',
    institute_add: 'institute/add',
    institute_edit: 'institute/edit',

    department_list: 'instituteDepartment/list',
    department_details: 'instituteDepartment',
    department_add: 'instituteDepartment/add',
    department_edit: 'instituteDepartment/edit',


    /** Doctor & Institute Menu Ends*/

    /** Doctor Call Menu Starts*/

    // visit
    visit_type_list: 'visitType/list',
    visitType_details: 'visitType',
    visitType_add: 'visitType/add',
    visitType_edit: 'visitType/edit',
    visit_list: 'visit/list',
    visit_details: 'visit',
    visit_add: 'visit/add',
    visit_edit: 'visit/edit',
    visit_approve: 'visit/approve',

    // doctor call
    doctor_visit_list: 'doctorVisit/list',
    export_doctor_visit_list: 'doctorVisit/exportDcrList',
    doctor_visit_approve: 'doctorVisit/approve',
    doctor_visit_bulk_approve: 'doctorVisit/bulkApprove',
    doctor_visit_details: 'doctorVisit',
    doctor_visit_add: 'doctorVisit/add',
    doctor_visit_edit: 'doctorVisit/edit',
    doctor_visit_type_list: 'doctorVisitType/list',
    doctor_visit_type_details: 'doctorVisitType',
    doctor_visit_type_add: 'doctorVisitType/add',
    doctor_visit_type_edit: 'doctorVisitType/edit',
    doctor_visit_locations: 'doctorVisit/locations',
    doctor_order_details: 'doctorOrder',



    // sample & gift
    sample_stock_list: 'sampleStock/list',
    sample_stock_add: 'sampleStock/set',
    sample_stock_edit: 'sampleStock/edit',

    sample_transactions: 'sampleStock/transactions',

    transfer_sample_stock: 'sampleStock/transferUserStock',

    sample_stock_allocation_list: 'sampleStock/allocationList',
    stock_approve: 'sampleStock/allocation/approve',
    export_sample_stock_allocation_list: 'sampleStock/allocationList/export',

    /** Doctor Call Menu Ends*/

    /** Rx Menu Starts*/

    // rx
    prescription_list: 'prescription/list',
    prescription_image_list: 'prescription/list/images',
    prescription_details: 'prescription',
    prescription_add: 'prescription/add',
    prescription_edit: 'prescription/edit',
    prescription_approve: 'prescription/approve',
    prescription_approve_with_rx_type: 'prescription/approveWithRxType',
    prescription_reject_with_reason: 'prescription/rejectWithReason',
    update_reason: 'prescription/updateRejectReason',
    export_prescription_list: 'prescription/list/export',
    similar_rx_list: 'prescription/similar-rx-list',
    non_duplicate_rx_remove: 'prescription/rx-not-duplicate',

    prescription_gallery_export: 'prescription/list/images/export',

    prescription_type_list: 'prescriptionType/list',
    prescription_type_details: 'prescriptionType',
    prescription_type_add: 'prescriptionType/add',
    prescription_type_edit: 'prescriptionType/edit',

    reject_reason_list: 'rxRejectReason/list',
    reject_reason_add: 'rxRejectReason/add',
    reject_reason_edit: 'rxRejectReason/edit',

    rx_form_list: 'api/rxFrom/',
    create_rx_from: 'api/rxFrom/manage',

    seen_rx_list: 'seenRx/list',
    seen_rx_details: 'seenRx',
    seen_rx_edit: 'seenRx/edit',
    seen_rx_add: 'seenRx/add',
    seen_rx_approve: 'seenRx/approve',


    prescription_approval_rule_list: 'rxApprovalRule/v2/list',
    add_prescription_approval_rule: 'rxApprovalRule/v2/add',
    delete_prescription_approval_rule: 'rxApprovalRule/v2',


    /** Rx Menu Ends*/

    /** Rx Survey Menu Starts*/

    // rx survey list
    rx_survey_list: 'rxSurvey/list',
    rx_survey_approve: 'rxSurvey/approve',
    rx_survey_edit: 'rxSurvey/edit',
    rx_survey_details: 'rxSurvey',

    // rx survey type list
    rx_survey_type_list: 'rxSurveyType/list',
    rx_survey_type_add: 'rxSurveyType/add',
    rx_survey_type_edit: 'rxSurveyType/edit',
    rx_survey_type_details: 'rxSurveyType',

    /** Rx Survey Menu Ends*/

    /** Expense Claim Menu Starts */

    // expense claim
    expense_claim_list: 'expenseClaim/list',
    expense_claim_list_export: 'expenseClaim/export',

    mileageClaim_list: 'mileageClaim/list',
    mileageClaim_details: 'mileageClaim',
    mileageClaim_edit: 'mileageClaim/edit',
    mileageClaim_add: 'mileageClaim/add',
    mileageClaim_approve: 'mileageClaim/approve',
    mileageClaim_export: 'mileageClaim/export',
    mileageClaim__reset_approval: 'mileageClaim/resetStatus',

    // monthly allowance
    monthlyAllowance_list: 'monthlyAllowance/list',
    monthlyAllowance_details: 'monthlyAllowance',
    monthlyAllowance_add: 'monthlyAllowance/add',
    monthlyAllowance_edit: 'monthlyAllowance/edit',

    expense_claim_approval: 'expenseClaim/approve',
    expense_claim_details: 'expenseClaim',
    expense_claim_add: 'expenseClaim/add',
    expense_claim_edit: 'expenseClaim/edit',
    expense_claim_reset_approval: 'expenseClaim/resetStatus',

    // daily allowance
    taDaMarketRule_list: 'taDaMarketRule/list',
    taDaMarketRule_details: 'taDaMarketRule',
    taDaMarketRule_add: 'taDaMarketRule/add',
    taDaMarketRule_edit: 'taDaMarketRule/edit',

    ta_da_claim_list: 'taDaClaim/list',
    ta_da_claim_list_export: 'taDaClaim/export',
    ta_da_claim_details: 'taDaClaim',
    ta_da_claim_edit: 'taDaClaim/edit',
    ta_da_claim_add: 'taDaClaim/add',
    ta_da_claim_approve: 'taDaClaim/approve',
    ta_da_claim_reset_approval: 'taDaClaim/resetStatus',

    role_wise_daily_allowances_list: 'api/v1/role-wise-daily-allowances/list',
    role_wise_daily_allowances_details: 'api/v1/role-wise-daily-allowances/getDetail',
    role_wise_daily_allowances_add: 'api/v1/role-wise-daily-allowances/add',
    role_wise_daily_allowances_update: 'api/v1/role-wise-daily-allowances/update',
    role_wise_daily_allowances_delete: 'api/v1/role-wise-daily-allowances/delete',
    role_wise_daily_allowances_inactive: 'api/v1/role-wise-daily-allowances/inactiveRoleWiseDA',

    user_vehicle_list_by_user_Id: 'api/v1/user-vehicle/userVehicleList',
    user_vehicle_add: 'api/v1/user-vehicle/add',
    user_vehicle_update: 'api/v1/user-vehicle/update',
    user_vehicle_inactive: 'api/v1/user-vehicle/inactive',
    user_vehicle_details_by_user_Id: 'api/v1/user-vehicle/getDetailByUserId',
    user_vehicle_details_by_Id: 'api/v1/user-vehicle/getDetailById',
    user_vehicle_list: 'api/v1/user-vehicle/userVehicleList',
    user_vehicle_details: 'api/v1/user-vehicle/getDetailById',
    user_vehicle_approve: 'api/v1/user-vehicle/approve-vehicle-request',

    da_claim_list: 'api/daClaim/getDAClaimList',
    da_claim_approve: 'api/daClaim/approve',
    pending_da_claim_list: 'api/daClaim/list/waiting-for-approval',
    da_claim_export: 'api/daClaim/list/export',

    // user allowance
    ma_claim_user_list: 'api/maClaim/getUserList',
    ma_claim_list: 'api/maClaim/list',
    ma_claim_generate: 'api/maClaim/generate',
    ma_claim_regenerate: 'api/maClaim/reGenerate',
    ma_claim_details: 'api/maClaim/getDetails',
    edit_ma_claim: 'api/maClaim/edit',
    ma_claim_approved: 'api/maClaim/approve',
    pending_ma_claim_list: 'api/maClaim/list/waiting-for-approval',
    ma_claim_print: 'api/maClaim/print',
    generate_all_ma_claim: 'api/maClaim/generateAll',
    ma_claim_export: 'api/maClaim/list/export',
    ma_claim_bulk_approve: 'api/maClaim/approve/bulk',
    ma_claim_approve_all: 'api/maClaim/list/approve-all',
    ma_claim_reject_all: 'api/maClaim/list/reject-all',
    ma_claim_details_export: 'api/maClaim/getDetails/export',

    role_wise_da_rule_list: 'api/v1/role-wise-daily-allowances/list',
    role_wise_da_rule_add: 'api/v1/role-wise-daily-allowances/add',
    role_wise_da_rule_update: 'api/v1/role-wise-daily-allowances/update',
    role_wise_da_rule_inactive: 'api/v1/role-wise-daily-allowances/inactiveRoleWiseDA',
    role_wise_da_rule_delete: 'api/v1/role-wise-daily-allowances/delete',
    role_wise_da_rule_active: 'api/v1/role-wise-daily-allowances/activeRoleWiseDA',

    role_wise_monthly_allowance_list: 'api/v1/role-wise-monthly-allowances/list',
    role_wise_monthly_allowance_details: 'api/v1/role-wise-monthly-allowances/getDetail',
    role_wise_monthly_allowance_add: 'api/v1/role-wise-monthly-allowances/add',
    role_wise_monthly_allowance_update: 'api/v1/role-wise-monthly-allowances/update',
    role_wise_monthly_allowance_inactive: 'api/v1/role-wise-monthly-allowances/inactive',
    role_wise_monthly_allowance_delete: 'api/v1/role-wise-monthly-allowances/delete',

    role_wise_expense_type_list: 'api/v1/role-wise-expense-type/list',
    role_wise_expense_type_manage: 'api/v1/role-wise-expense-type/manage',
    role_wise_expense_type_delete: 'api/v1/role-wise-expense-type/delete',
    role_wise_expense_type_change_activation: 'api/v1/role-wise-expense-type/change-activation',

    da_claim_approval_rule_add: 'daClaimApprovalRule/add',
    da_claim_approval_rule_delete: 'daClaimApprovalRule',
    da_claim_approval_rule_list: 'daClaimApprovalRule/list',

    ma_claim_approval_rule_add: 'monthlyExpenseApprovalRule/add',
    ma_claim_approval_rule_delete: 'monthlyExpenseApprovalRule/delete',
    ma_claim_approval_rule_list: 'monthlyExpenseApprovalRule/list',

    // expense claim settings
    expense_type_list: 'expenseType/list',
    expense_type_details: 'expenseType',
    expense_type_add: 'expenseType/add',
    expense_type_edit: 'expenseType/edit',

    user_distance_wise_ta_da_rule_list: 'userDistanceWiseTaDaRule/list',
    user_distance_wise_ta_da_rule_details: 'userDistanceWiseTaDaRule',
    user_distance_wise_ta_da_rule_add: 'userDistanceWiseTaDaRule/add',
    user_distance_wise_ta_da_rule_delete: 'userDistanceWiseTaDaRule',
    user_distance_wise_ta_da_rule_location_delete: 'userDistanceWiseTaDaRule',
    user_details_distance_wise_ta_da_rule_location: 'userDistanceWiseTaDaRule/userHqLocation',

    user_distance_wise_ta_da_rule_upload: 'userDistanceWiseTaDaRule/upload',

    transport_method_list: 'transport/list',
    transport_method_details: 'transport',
    transport_method_add: 'transport/add',
    transport_method_edit: 'transport/edit',

    /** Expense Claim Menu Ends */

    /** HR Menu Starts */

    // attendance
    attendance_list: 'attendance/list',
    attendance_reset: 'attendance/resetApproval',
    attendance_add: 'attendance/add',
    attendance_edit: 'attendance/edit',
    export_attendance_list: 'attendance/list/export',

    // leave
    leave_type_list: 'leaveType/list',
    leave_type_details: 'leaveType',
    leave_type_add: 'leaveType/add',
    leave_type_edit: 'leaveType/edit',

    leave_allocation_list: 'leaveAllocation/list',
    leave_allocation_details: 'leaveAllocation',
    leave_allocation_add: 'leaveAllocation/add',
    leave_allocation_edit: 'leaveAllocation/edit',

    leave_account_list: 'leaveAccount/list',
    leave_account_manage: 'leaveAccount/manage',

    multiple_leave_add: 'userLeave/multipleLeaveCreation',
    user_leave_dates: 'userLeave/leaveListOfUser',
    user_leave_list: 'userLeave/list',
    user_leave_details: 'userLeave',
    user_leave_add: 'userLeave/add',
    user_leave_edit: 'userLeave/edit',
    user_leave_bulk_reject: 'userLeave/rejectAllLeaves',
    user_leave_export: 'userLeave/export',
    user_leave_account: 'leaveReport/userAccountList',


    // notice board
    notice_board_list: 'noticeBoard/listOfSubordinates',
    notice_details: 'noticeBoard',
    notice_edit: 'noticeBoard/edit',
    notice_add: 'noticeBoard/add',
    update_notice_board_active_status: 'noticeBoard/updateActiveStatus',

    // hr settings
    holiday_list: 'holiday/list',
    holiday_details: 'holiday',
    holiday_add: 'holiday/add',
    holiday_edit: 'holiday/edit',

    weekend_request_list: 'weekend/requestList',
    edit_weekend_request: 'weekend/editRequest',
    approve_weekend_request: 'weekend/approveRequest',
    set_weekend_request: 'weekend/setWeekendForUser',

    daily_shift_list: 'dailyShift/list',
    daily_shift_details: 'dailyShift',
    daily_shift_add: 'dailyShift/add',
    daily_shift_edit: 'dailyShift/edit',

    /** HR Menu Ends */

    /** Training & Exam Menu Starts */

    // training
    training_list: 'training/listOfSubordinates',
    training_details: 'training',
    training_edit: 'training/edit',
    training_comment: 'training/comment',
    training_add: 'training/add',

    // exam
    exam_list: 'exam/list',
    delete_exam: 'exam',
    exam_details: 'exam',
    exam_v2_list: 'exam/list/underMe',
    exam_add: 'exam/add',
    exam_edit: 'exam/edit',
    exam_response_list: 'examRespondent/list',
    exam_response_details: 'examRespondent',
    exam_evaluation_save: 'examRespondent/evaluate',

    // exam v2
    exam_list_v2: 'exam/list/underMe',
    exam_create: 'exam/create',
    exam_update: 'exam/update',
    exam_info: 'exam/info',
    set_questions: 'exam/setQuestions',
    question_info: 'exam/questionPaper',
    attended_absent_passed_count: 'result/attendedAbsentPassedCount',
    attended_user_result: 'result/attendedUsers',
    attended_user_result_export: 'result/attendedUsers/export',
    absent_user_result: 'result/absentUsers',
    exam_answer_paper: 'result/answerPaper',
    evaluate_exam: 'exam/evaluate',

    /** Training & Exam Menu Ends */

    /** KPI Menu Starts */

    // target achievement
    market_sales_target_list: 'marketSalesTarget/list',
    market_product_sales_target_list: 'marketProductSalesTarget/list',
    market_product_sales_target_list_quarter: 'marketProductSalesTarget/listOfQuarter',
    daily_target_achievement_list: 'dailySalesTarget/list',
    market_sales_target_details: 'marketSalesTarget',
    daily_sales_target_details: 'dailySalesTarget',
    market_sales_target_add: 'marketSalesTarget/add',
    market_sales_target_edit: 'marketSalesTarget/edit',
    daily_sales_target_set: 'dailySalesTarget/set',
    daily_sales_target_add: 'dailySalesTarget/add',
    daily_sales_target_edit: 'dailySalesTarget/edit',
    product_sales_target_list: 'api/v1/market-product-sales-target/list',
    product_sales_target_market_list: 'api/v1/market-product-sales-target/marketList',
    product_sales_target_details: 'marketProductSalesTarget',
    product_sales_target_add: 'marketProductSalesTarget/add',
    product_sales_target_edit: 'marketProductSalesTarget/edit',
    user_rx_target_and_count: 'rxTarget/report/rx-target-and-count',
    user_rx_target_and_count_export: 'rxTarget/report/rx-target-and-count/export',
    market_sales_target_upload: 'api/v1/market-sales-target/upload_market_sales_target',
    market_wise_sales_target_add: 'api/v1/market-sales-target/add_market_sales_target',
    market_wise_sales_target_list: 'api/v1/market-sales-target/list',
    market_wise_sales_target_list_market_hierarchy: 'api/v1/market-sales-target/marketList',
    market_wise_product_sales_market_hierarchy: 'api/v1/market-product-sales-target/marketList',
    export_market_wise_sales_target_list: 'api/v1/market-sales-target/export',
    market_product_sales_target_add: 'api/v1/market-product-sales-target/add',
    market_product_sales_target_upload: 'api/v1/market-product-sales-target/upload_market_product_sales_target',
    market_product_sales_target_delete: 'api/v1/market-product-sales-target',
    export_market_product_wise_sales_target_list: 'api/v1/market-product-sales-target/export',
    market_product_target_achievement_list: 'api/v1/market-product-sales-target/targetAchievementList',
    market_product_target_achievement_market_hierarchy: 'api/v1/market-product-sales-target/marketList',
    export_market_product_wise_sales_target_achievement_list: 'api/v1/market-product-sales-target/targetAchievementList/export',


    /** KPI Menu Ends */


    /** Location Menu Starts */

    user_location_list: 'location/userLocationList',
    user_location_list_v2: 'location/userLocationList/v2',
    user_last_location_list: 'location/getLastLocationList',
    user_last_location_list_v2: 'location/v2/getLastLocationList',
    user_last_location_list_v2_export: 'location/v2/exportLastLocation',
    device_list: 'userDevice/list',
    delete_user_device: 'userDevice',
    user_location_delete: 'user/attendanceLocation',
    user_timeline: 'location/userLocation/timeline',
    timeline_by_date_range: 'location/userLocation/timeline/multipleDates',
    export_timeline_by_date_range: 'location/userLocation/timeline/multipleDates/export',
    chemist_doctor_location: 'location/chemistAndDoctorLocation',
    user_last_locations: 'api/location-tracking/last-location',
    user_timeline_by_date: 'api/location-tracking/user-timeline-by-date',
    user_timeline_by_date_range: 'api/location-tracking/user-timeline-by-date-range',
    event_list: 'api/app-event/get-app-event',
    export_user_timeline_by_date_range: 'api/location-tracking/user-timeline-by-date-range/export',

    /** Location Menu Ends */

    /** Others Menu Starts */

    // contact
    contact_type_list: 'contactType/list',
    contact_type_details: 'contactType',
    contact_type_add: 'contactType/add',
    contact_type_edit: 'contactType/edit',

    // segment
    segment_list: 'segment/list',
    segment_details: 'segment',
    segment_add: 'segment/add',
    segment_edit: 'segment/edit',

    // sub segment
    sub_segment_list: 'subSegment/list',
    sub_segment_details: 'subSegment',
    sub_segment_add: 'subSegment/add',
    sub_segment_edit: 'subSegment/edit',

    /** Others Menu Ends */

    /** Product Menu Starts */

    product_list: 'product/list',
    product_list_for_filter: 'api/product/list-for-filter',
    export_product_list: 'product/export',
    product_details: 'product',
    product_add: 'product/add',
    product_edit: 'product/edit',

    competitor_list: 'competitor/list',
    competitor_details: 'competitor',
    competitor_add: 'competitor/add',
    competitor_edit: 'competitor/edit',

    competitor_product_list: 'competitorProduct/list',
    competitor_product_details: 'competitorProduct',
    competitor_product_add: 'competitorProduct/add',
    competitor_product_edit: 'competitorProduct/edit',

    competitor_brand_list: 'competitorBrand/list',
    competitor_brand_add: 'competitorBrand/add',
    competitor_brand_edit: 'competitorBrand/edit',
    competitor_brand_details: 'competitorBrand',
    competitor_brand_upload: 'competitorBrand/upload',

    product_line_list: 'productLine/list',
    product_line_details: 'productLine',
    product_line_add: 'productLine/add',
    product_line_edit: 'productLine/edit',

    product_price_list: 'productPriceList/list',
    product_price_list_details: 'productPriceList',
    product_price_edit: 'productPriceList/edit',
    product_price_add: 'productPriceList/add',

    product_brand_list: 'productBrand/list',
    product_brand_details: 'productBrand',
    product_brand_add: 'productBrand/add',
    product_brand_edit: 'productBrand/edit',
    product_brand_detailed_list: 'api/product-brand/detailed-list',
    product_brand_detail: 'api/product-brand/detail',
    product_brand_add_v2: 'api/product-brand/add',
    product_brand_edit_v2: 'api/product-brand/edit',

    product_type_list: 'productType/list',
    product_type_details: 'productType',
    product_type_add: 'productType/add',
    product_type_edit: 'productType/edit',

    product_dose_list: 'productDoseForm/list',
    product_dose_details: 'productDoseForm',
    product_dose_add: 'productDoseForm/add',
    product_dose_edit: 'productDoseForm/edit',

    therapeutic_group_list: 'therapeuticGroup/list',
    therapeutic_group_details: 'therapeuticGroup',
    therapeutic_group_add: 'therapeuticGroup/add',
    therapeutic_group_edit: 'therapeuticGroup/edit',

    generic_group_list: 'genericGroup/list',
    generic_group_details: 'genericGroup',
    generic_group_add: 'genericGroup/add',
    generic_group_edit: 'genericGroup/edit',

    focus_brand_list: 'focusBrand/activeFocusBrands',
    focus_brand_edit: 'focusBrand/edit',
    focus_brand_add: 'focusBrand/add',
    delete_focus_brand: 'focusBrand',
    focus_brand_details: 'focusBrand/activeFocusBrands',


    order_product_list: 'productPriceList/priceOfProducts',
    product_and_competitor_product_list: 'product/productListAndCompetitorProductList',
    product_price_details_list: 'productPriceList/catalogByPriceListId',
    product_price_details_updateProductPrice: 'productPriceList/updateProductPrice',
    minified_product_list: 'prescription/userAndProductWiseRxCount/product',

    product_brand_tag_list: 'api/product-brand-tag/list',
    product_brand_tag_status_activation: 'api/product-brand-tag/updateActiveStatus',
    product_brand_tag_add: 'api/product-brand-tag/add',
    product_brand_tag_edit: 'api/product-brand-tag/edit',

    /** Product Menu Ends */

    /** Sales & Collection Menu Starts */

    // sales
    order_list: 'order/list',
    order_add: 'order/add',
    order_list_export: 'order/exportOrderList',
    order_edit: 'order/edit',
    order_approve: 'order/approve',
    order__reset_approval: 'order/resetStatus',
    order_details: 'order',
    doctor_order_list: 'doctorOrder/list',
    export_doctor_order: 'doctorOrder/export',

    dms_order_details: 'api/v1/order',
    order_list_for_depot_user: 'api/v1/order/listForDepotUser',
    order_details_for_depot_user: 'api/v1/order',
    dms_order_approve: 'api/v1/order/approve',
    dms_order_list: 'api/v1/order/list',
    dms_order_list_summary: 'api/v1/order/list/summary',
    list_of_delivery_person: 'user/listOfDeliveryPerson',

    order_alpha_list: 'api/v2/order/list',
    order_alpha_details: 'api/v2/order',
    order_alpha_add: 'api/v2/order/create',
    order_alpha_edit: 'api/v2/order/edit',
    order_alpha_preview: 'api/v2/order/preview',
    order_alpha_export: 'api/v2/order/order-list-with-order-quantity/export',
    order_alpha_approve: 'api/v2/order/approve',
    order_alpha_reset: 'api/v2/order/reset',
    order_alpha_by_mpo_list: 'api/v2/order/order-by-mpo',
    export_order_alpha_by_mpo_list: 'api/v2/order/order-by-mpo/export',
    order_alpha_approval_rule_list: 'orderApprovalRule/v2/list',
    add_order_alpha_approval_rule: 'orderApprovalRule/v2/add',
    delete_order_alpha_approval_rule: 'orderApprovalRule/v2',
    order_alpha_detail_by_mpo: 'api/v2/order/order-by-mpo/by-mpo-id',
    update_order_status: 'api/v2/order/update-order-status-to-sent-to-depot',
    order_alpha_total: 'api/v2/order/list/total',

    campaign_list: 'campaign/list',
    campaign_details: 'campaign',
    campaign_add: 'campaign/add',
    campaign_edit: 'campaign/edit',

    line_item_offer_list: 'api/line_item_bonus_discount/list',
    line_item_offer_add: 'api/line_item_bonus_discount/add',
    line_item_offer_update: 'api/line_item_bonus_discount/update',
    line_item_offer_details: 'api/line_item_bonus_discount/details',
    line_item_offer_activate: 'api/line_item_bonus_discount/activate',

    total_order_amount_offer_list: 'api/total_order_amount_offer/list',
    total_order_amount_offer_add: 'api/total_order_amount_offer/add',
    total_order_amount_offer_update: 'api/total_order_amount_offer/update',
    total_order_amount_offer_details: 'api/total_order_amount_offer/details',
    total_order_amount_offer_activate: 'api/total_order_amount_offer/activate',

    flat_rate_list: 'api/campaign-basic/flat-rate/list',
    flat_rate_add: 'api/campaign-basic/flat-rate/create',
    flat_rate_edit: 'api/campaign-basic/flat-rate/edit',
    flat_rate_details: 'api/campaign-basic/flat-rate/detail',
    flat_rate_update_status: 'api/campaign-basic/flat-rate/update-status',

    discount_on_sale_list: 'api/campaign-basic/discount-on-sale/list',
    discount_on_sale_details: 'api/campaign-basic/discount-on-sale/detail',
    discount_on_sale_edit: 'api/campaign-basic/discount-on-sale/edit',
    discount_on_sale_add: 'api/campaign-basic/discount-on-sale/create',
    discount_on_sale_update_status: 'api/campaign-basic/discount-on-sale/update-status',

    campaign_basic_bonus_list: 'api/campaign-basic/bonus/list',
    campaign_basic_bonus_add: 'api/campaign-basic/bonus/create',
    campaign_basic_bonus_edit: 'api/campaign-basic/bonus/edit',
    campaign_basic_bonus_details: 'api/campaign-basic/bonus/detail',
    campaign_basic_bonus_update_status: 'api/campaign-basic/bonus/update-status',

    special_campaign_list: 'api/special-campaign/list',
    special_campaign_add: 'api/special-campaign/create',
    special_campaign_edit: 'api/special-campaign/edit',
    special_campaign_details: 'api/special-campaign/detail',
    special_campaign_update_status: 'api/special-campaign/bonus/update-status',
    get_available_optional_special_campaign: 'api/special-campaign/get-available-optional-special-campaigns',

    party_campaign_list: 'api/party-campaign/list',
    party_campaign_add: 'api/party-campaign/create',
    party_campaign_edit: 'api/party-campaign/edit',
    party_campaign_details: 'api/party-campaign/detail',
    party_campaign_update_status: 'api/party-campaign/update-status',

    party_type_campaign_list: 'api/party-type-campaign/list',
    party_type_campaign_add: 'api/party-type-campaign/create',
    party_type_campaign_edit: 'api/party-type-campaign/edit',
    party_type_campaign_details: 'api/party-type-campaign/detail',
    party_type_campaign_update_status: 'api/party-type-campaign/update-status',

    bundle_offer_campaign_add: 'api/campaign-basic/bundle-offer/create',
    bundle_offer_campaign_edit: 'api/campaign-basic/bundle-offer/edit',
    bundle_offer_campaign_details: 'api/campaign-basic/bundle-offer/detail',
    bundle_offer_campaign_list: 'api/campaign-basic/bundle-offer/list',
    bundle_offer_campaign_status_update: 'api/campaign-basic/bundle-offer/update-status',

    mixed_product_offer_campaign_list: 'api/campaign-basic/mix-product-offer/list',
    mixed_product_offer_campaign_add: 'api/campaign-basic/mix-product-offer/create',
    mixed_product_offer_campaign_details: 'api/campaign-basic/mix-product-offer/detail',
    mixed_product_offer_campaign_edit: 'api/campaign-basic/mix-product-offer/edit',
    mixed_product_offer_campaign_status_update: 'api/campaign-basic/mix-product-offer/update-status',


    inv0ice_details: 'invoice',
    inv0ice_list: 'invoice/list',
    invoice_export: 'invoice/export',
    invoice_add: 'invoice/add',

    invoice_sync_list: 'invoice/sync/list',
    invoice_sync_details: 'invoice/sync',


    dms_invoice_list: 'api/v1/invoice/list',
    dms_invoice_list_for_depot_user: 'api/v1/invoice/listForDepotUser',
    dms_invoice_export: 'api/v1/invoice/list/export',
    dms_create_invoice: 'api/v1/invoice/create_invoice',
    dms_invoice_calculate_price: 'api/v1/invoice/calculate_price',
    dms_invoice_details: 'api/v1/invoice',
    dms_invoice_update: 'api/v1/invoice/update_invoice',
    dms_invoice_delivery: 'api/v1/invoice/delivery',
    dms_invoice_reject: 'api/v1/invoice/reject',
    dms_invoice_create_by_order_id: 'api/v1/invoice/create_invoice_by_order',
    dms_invoice_summary_for_depot_user: 'api/v1/invoice/listForDepotUser/summary',
    dms_invoice_summary: 'api/v1/invoice/list/summary',
    dms_invoice_delivery_invoice_equal_amount_of_payment: 'api/v1/invoice/deliverInvoiceEqualAmountOfPayment',
    dms_invoice_reject_with_payment: 'api/v1/invoice/rejectWithPayment',
    dms_invoice_list_to_print: 'api/v1/invoice/list-to-print',
    dms_invoice_type_list: 'api/v1/invoice-type/list',
    dms_invoice_type_add: 'api/v1/invoice-type/add',
    dms_invoice_type_edit: 'api/v1/invoice-type/edit',
    dms_invoice_type_details: 'api/v1/invoice-type',
    dms_invoice_product_wise_top_sheet: 'api/v1/invoice/product-wise-top-sheet',
    delivery_return_add: 'api/v1/delivery-return/add',
    delivery_return_list: 'api/v1/delivery-return/list',
    delivery_return_approve: 'api/v1/delivery-return/approve',
    delivery_return_details: 'api/v1/delivery-return',
    sales_return_total: 'api/salesReturn/list/total',
    chemist_list_for_payment: 'api/v1/payment-collection/chemist-list',
    delivery_return_total: 'api/v2/delivery-return/list/total',
    delivery_return_cancel: 'api/v2/delivery-return/cancel',
    dms_sales_return_pdf: 'api/salesReturn/details-print',
    dms_sales_return_bulk_pdf: 'api/salesReturn/bulk-print',

    invoice_alpha_list: 'api/v2/invoice/list',
    invoice_alpha_details: 'api/v2/invoice',
    invoice_alpha_add: 'api/v2/invoice/create',
    invoice_alpha_edit: 'api/v2/invoice/edit',
    invoice_alpha_preview: 'api/v2/invoice/preview',
    invoice_alpha_export: 'api/v2/invoice/list/export',
    invoice_alpha_delivery: 'api/v2/invoice/delivery',
    invoice_alpha_reject: 'api/v2/invoice/reject',
    invoice_alpha_reset: 'api/v2/invoice/reset',
    invoice_alpha_summary: 'api/v2/invoice/list/summary',
    multiple_invoice_alpha_create_by_order: 'api/v2/invoice/create-by-order',
    create_partial_invoice: 'api/v2/invoice/create-partial',
    delivery_return_list_v2: 'api/v2/delivery-return/list',
    delivery_return_details_v2: 'api/v2/delivery-return',
    delivery_return_edit_v2: 'api/v2/delivery-return/list',
    delivery_return_export_v2: 'api/v2/delivery-return/list/export',
    invoice_delivery_top_sheet: 'api/v2/invoice/delivery-top-sheet',
    invoice_details_pdf: 'api/v2/invoice/details-pdf',
    invoice_alpha_no_summary_list: 'api/v2/invoice/list-for-invoice-summary',
    invoice_alpha_summary_create: 'api/v2/invoice/summary/create',
    invoice_alpha_summary_list: 'api/v2/invoice/summary/list',
    chemist_wise_unpaid_invoice: 'api/v1/payment-collection/mpo-wise-payment/invoice-list',
    check_stock_for_bulk_invoice: 'api/v2/invoice/check-stock-for-bulk-invoice',
    invoice_alpha_bulk_summary_create: 'api/v2/invoice/summary/bulkcreate',

    delivery_details: 'delivery',
    delivery_list: 'delivery/list',
    delivery_approve: 'delivery/approve',

    return_list: 'return/list',
    return_details: 'return',

    dms_return_reason_list: 'api/v1/returnReason/list',
    dms_return_reason_add: 'api/v1/returnReason/add',
    dms_return_reason_edit: 'api/v1/returnReason/update',
    dms_return_reason_update_active_status: 'api/v1/returnReason/updateActiveStatus',

    dms_sales_return_list: 'api/salesReturn/list',
    dms_sales_return_details: 'api/salesReturn/details',
    dms_sales_return_add: 'api/salesReturn/add',
    dms_sales_return_update: 'api/salesReturn/update',
    dms_sales_return_approve: 'api/salesReturn/approve',
    get_invoice_details_for_sales_return: 'api/v2/invoice/details-for-sales-return',
    add_sales_return_from_invoice: 'api/salesReturn/add-with-invoice',
    update_sales_return_from_invoice: 'api/salesReturn/update-with-invoice',
    export_dms_sales_return_list: 'api/salesReturn/list/export',
    reset_dms_sales_return_list: 'api/salesReturn/reset',
    eligible_invoice_list_for_sales_return: 'api/v2/invoice/list-for-sales-return',

    delivery_return_add_v2: 'api/v2/delivery-return/create',
    delivery_return_preview: 'api/v2/delivery-return/preview',

    // payment collection

    payment_list: 'payment/list',
    payment_details: 'payment',
    payment_edit: 'payment/edit',
    payment_add: 'payment/add',
    payment_approve: 'payment/approve',

    payment_method_list: 'paymentMethod/list',
    payment_method_details: 'paymentMethod',
    payment_method_add: 'paymentMethod/add',
    payment_method_edit: 'paymentMethod/edit',

    bankAccount_list: 'bankAccount/list',
    bankAccount_details: 'bankAccount',
    bankAccount_edit: 'bankAccount/edit',
    bankAccount_add: 'bankAccount/add',

    dms_payment_list_by_depot_user: 'api/v2/payment/payments_by_depot_user',
    dms_payment_entry: 'api/v2/payment/entry_payment_for_invoice',
    dms_payment_collect: 'api/v2/payment/collect_payment_for_invoice',
    dms_payment_details: 'api/v2/payment',
    dms_payment_list_by_organization_user: 'api/v2/payment/payments_by_org_user',
    dms_payment_approve: 'api/v2/payment/approve_payment_for_invoice',
    dms_payment_reset: 'api/v2/payment/resetApproval',
    dms_payment_cards: 'api/v2/payment/payments/total',
    collect_payment_during_delivery: 'api/v2/payment/collect_payment_during_delivery',
    export_dms_payment_list_by_organization_user: 'api/v2/payment/payments_by_org_user/export',

    payment_collection_list: 'api/v1/payment-collection/list',
    payment_collection_create: 'api/v1/payment-collection/create',
    payment_collection_approve: 'api/v1/payment-collection/approve',
    payment_collection_details: 'api/v1/payment-collection',
    payment_collection_cancel: 'api/v1/payment-collection/cancel',
    payment_collection_chemist_due: 'api/v1/payment-collection/chemist-due',
    export_payment_collection_list: 'api/v1/payment-collection/list/export',
    bank_wise_payment_collection_list: 'api/v1/payment-collection/bank-wise-list',
    total_bank_wise_payment: 'api/v1/payment-collection/bank-wise-list/total',
    export_bank_wise_payment_collection_list: 'api/v1/payment-collection/bank-wise-list/export',
    create_mpo_wise_payment: 'api/v1/payment-collection/create/mpo-wise',
    mpo_wise_payment_collection_list: 'api/v1/payment-collection/list/mpo-wise',
    export_mpo_wise_payment_collection_list: 'api/v1/payment-collection/list/export/mpo-wise',
    payment_collection_receipt_print: 'api/v1/payment-collection/print-receipt',
    mpo_wise_payment_collection_approve: 'api/v1/payment-collection/approve/mpo-wise',
    mpo_wise_payment_collection_cancel: 'api/v1/payment-collection/cancel/mpo-wise',
    invoice_due_by_mpo_and_invoice_id: 'api/v2/invoice/mpo-invoice-due',

    depot_list: 'api/v1/depot/list',
    depot_add: 'api/v1/depot/add',
    depot_edit: 'api/v1/depot/update',
    depot_activate: 'api/v1/depot/activate',
    depot_details: 'api/v1/depot/details',

    depot_type_list: 'api/v1/depot_type/list',
    depot_type_add: 'api/v1/depot_type/add',
    depot_type_edit: 'api/v1/depot_type/edit',
    depot_type_activate: 'api/v1/depot_type/activate',

    save_user_depots: 'userDepot/updateUserDepot',
    depot_list_by_user: 'userDepot/getDepotsByUser',
    save_market_depot: 'api/marketDepot/updateMarketDepot',

    product_upload_to_depot: 'api/v1/depot_stock/upload_product_stock',
    depot_stock_list: 'api/v1/depot_stock/list',
    export_depot_stock_list: 'api/v1/depot_stock/list/export',
    depot_stock_cards: 'api/v1/depot_stock/get_depot_stock_summary_card',

    depot_new_requisition: 'api/v1/depot_requisition/new_requisition',
    sent_requisition_list: 'api/v1/depot_requisition/get_sent_depot_requisition_list',
    received_requisition_list: 'api/v1/depot_requisition/get_received_depot_requisition_list',
    depot_requisition_details: 'api/v1/depot_requisition/details_by_id',
    depot_update_requisition: 'api/v1/depot_requisition/update_requisition',
    depot_requisition_reject: 'api/v1/depot_requisition/reject',
    adjust_depot_stock: 'api/v1/depot_stock/adjust-depot-stock',

    sample_gift_challan_list: 'api/v1/sample-gift-challan/list',
    sample_gift_challan_list_export: 'api/v1/sample-gift-challan/list/export',
    sample_gift_challan_create: 'api/v1/sample-gift-challan/create',
    sample_gift_challan_edit: 'api/v1/sample-gift-challan/edit',
    sample_gift_challan_detail: 'api/v1/sample-gift-challan',
    sample_gift_challan_approve: 'api/v1/sample-gift-challan/approve',
    sample_gift_challan_reset_status: 'api/v1/sample-gift-challan/reset-status',
    sample_gift_challan_user_filter: 'user-filter/field-force',
    sample_gift_challan_pdf: 'api/v1/sample-gift-challan/list/pdf',

    depot_challan_from_requisition: 'api/v1/depot_challan/get_depot_challan_suggestion_from_requisition',
    crate_depot_challan: 'api/v1/depot_challan/create_depot_challan',
    issued_challan_list: 'api/v1/depot_challan/get_issued_challan_list',
    received_challan_list: 'api/v1/depot_challan/get_received_challan_list',
    challan_details: 'api/v1/depot_challan/details_by_id',
    receive_challan: 'api/v1/depot_challan/receive_depot_challan',
    reject_challan: 'api/v1/depot_challan/reject_depot_challan',
    depot_challan_export: 'api/v1/depot_challan/challan-summary/export',

    product_batch_list: 'api/product_batch_info/list',
    product_batch_add: 'api/product_batch_info/add',
    product_batch_update: 'api/product_batch_info/update',
    product_batch_delete: 'api/product_batch_info',

    depot_user_list: 'depotUser/list',

    allowed_depot_list_for_filter: 'api/v1/depot/allowed_depot_list_for_filter',

    // incentive collection
    incentive_rule_list: 'api/chemist-incentive-rule/list',
    incentive_rule_add: 'api/chemist-incentive-rule/add',
    incentive_rule_edit: 'api/chemist-incentive-rule/edit',
    incentive_list: 'api/chemist-incentive/list',
    generate_incentive: 'api/chemist-incentive/generate-incentive',
    incentive_list_export: 'api/chemist-incentive/list/export',
    generate_incentive_status: 'api/chemist-incentive/generate-incentive/status',
    adjust_incentive_by_chemist: 'api/chemist-incentive/adjustable-incentive-by-chemist',
    due_invoice_list_by_chemist: 'api/v1/invoice/due-invoice-list-by-chemist',
    incentive_adjustment_add: 'api/v2/payment/incentive-adjustment/add',
    incentive_adjustment_cancel: 'api/v2/payment/incentive-adjustment/cancel',
    return_adjustment_cancel: 'api/v2/payment/return-adjustment/cancel',
    upload_incentive: 'api/chemist-incentive/upload-incentive',

    /** Sales & Collection Menu Ends */

    /** Stock Menu Starts */

    // central stock
    centralStockList: 'centralStock/list',
    central_stock_add: 'centralStock/add',

    central_stock_transfer_approve: 'centralStock/transfer/approve',
    centralStock_transfer_list: 'centralStock/transfer/list',
    central_stock_transfer_details: 'centralStock/transfer',
    stock_transfer_add: 'centralStock/transfer',

    // stock
    stock_list: 'stock/stockOfASalesCenter',
    stock_add: 'stock/set',
    stock_edit: 'stock/edit',

    // sales center
    sales_center_list: 'salesCenter/list',
    sales_center_details: 'salesCenter',
    sales_center_add: 'salesCenter/add',
    sales_center_edit: 'salesCenter/edit',
    sales_center_of_market: 'salesCenter/of-market',

    distributor_route_list: 'distributionRoute/list',
    route_details: 'distributionRoute',
    route_edit: 'distributionRoute/edit',
    route_add: 'distributionRoute/add',
    sales_center_list_by_ids: 'salesCenter/list-by-ids',

    /** Stock Menu Ends */

    /** Site Menu Starts */

    // site menu
    site_list: 'site/list',
    site_details: 'site',
    site_edit: 'site/edit',
    site_add: 'site/add',
    site_approve: 'site/approve',

    // site settings
    site_type_list: 'siteType/list',
    site_type_details: 'siteType',
    ssite_type_add: 'siteType/add',
    site_type_edit: 'siteType/edit',

    site_owner_list: 'siteOwnerType/list',
    site_owner_details: 'siteOwnerType',
    ssite_owner_add: 'siteOwnerType/add',
    site_owner_edit: 'siteOwnerType/edit',

    /** Site Menu Ends */


    /** Team Management Menu Starts */

    // user
    user_list: 'user/list',
    accompany_list: 'userRole/visitWithList',
    export_user_list: 'user/export',
    user_details: 'user',
    change_user_status: 'user/active',
    user_add: 'user/add',
    user_edit: 'user/edit',
    user_list_by_accessible_market: 'user/listByAccessibleMarket',
    all_user_list: 'userFilter/list',
    user_booked_amount: 'api/v1/bookedAmount/user',
    all_user_mpo_list: 'userFilter/get-all-mpo',
    mpo_list: 'user/mpoList',

    user_credit_upload: 'user/updateCreditLimit',
    user_list_by_ids: 'user/list-by-ids',

    find_mpo_by_search: 'user/mpoInfo',

    // market
    market_list: 'market/list',
    export_market_list: 'market/export',
    market_list_by_distributor: 'market/operatingMarketListOnDistributor',
    market_list_by_customer: 'market/operatingMarketListOnCustomer',
    market_list_by_distributor_and_customer: 'market/operatingMarketListOnCustomerAndDistributor',
    market_details: 'market',
    market_add: 'market/add',
    market_edit: 'market/edit',
    market_delete: 'market',
    market_level_list: 'marketLevel/getMarketLevelHierarchy',
    market_mini_list: 'market/mini/list',
    market_list_by_ids: 'market/list-by-ids',
    mpo_marketLevel: 'marketLevel/mpoLevel',
    market_and_users_of_a_level: 'market/usersByMarketLevel',

    /** Team Management Menu Ends */

    /** Work Schedule Menu Starts */

    // planned user list
    doctor_visit_plan_user_list: 'doctorVisitPlan/plannedUserList',
    doctor_visit_plan_approve: 'doctorVisitPlan/approve',
    doctor_visit_plan_list: 'doctorVisitPlan/list',
    dvp_planned_users: 'api/dvp/planned-users',
    dvp_planned_users_export: 'api/dvp/planned-users/export',
    dvp_user_schedule: 'api/dvp/user-schedule',
    dvp_user_schedule_export: 'api/dvp/user-schedule/export',

    // tour plan
    tour_plan_user_list: 'tourPlan/plannedUserList',
    tour_plan_list_v2: 'tourPlan/v2/list',
    tour_plan_details: 'tourPlan',
    tour_plan_details_by_user_year_month: 'tourPlan/details',
    tour_plan_manage: 'tourPlan/manage',
    tour_plan_manage_v2: 'tourPlan/v2/manage',
    tour_plan_approve: 'tourPlan/approve',
    tour_plan_list: 'tourPlan/list',
    tourplan_reset: 'tourPlan/resetStatus',

    // tour type
    tour_type_details: 'tourType',
    tour_type_add: 'tourType/add',
    tour_type_edit: 'tourType/edit',

    // tour purpose
    tour_purpose_list: 'tourPurpose/list',
    tour_purpose_details: 'tourPurpose',
    tour_purpose_add: 'tourPurpose/add',
    tour_purpose_edit: 'tourPurpose/edit',
    tour_type_list: 'tourType/list',
    export_monthly_tour_plans: 'tourPlan/exportMonthlyTourPlan',
    tour_plan_of_a_person: 'tourPlan/planOfPerson',
    tour_plan_of_a_person_export: 'tourPlan/planOfPerson/export',
    tour_plan_market_frequency_of_a_person: 'tourPlan/planOfPerson/marketFrequency',
    tour_plan_tour_type_frequency: 'tourPlan/planOfPerson/tourTypeFrequency',

    /** Work Schedule Menu Ends */

    /** Super Admin Starts */

    // dashboard
    dashboard_hit_count: 'actuator/hitCount',

    // bill pending organization
    bill_pending_organization_list: 'billPendingOrg/list',
    add_bill_pending_organization: 'billPendingOrg/add',
    delete_bill_pending_organization: 'billPendingOrg',
    set_restriction_message: 'billPendingOrg/setRestrictionMessage',
    get_restriction_message: 'billPendingOrg/getRestrictionMessage',

    // chemist approval rules
    customer_approve_list: 'chemistApprovalRule/list',
    customer_approve_add: 'chemistApprovalRule/add',
    customer_approve_edit: 'chemistApprovalRule/edit',
    customer_approve_delete: 'chemistApprovalRule',
    customer_approve_details: 'chemistApprovalRule',
    chemist_approval_rule_list: 'chemistApprovalRule/v2/list',
    chemist_approval_rule_delete: 'chemistApprovalRule/v2/delete',
    chemist_approval_rule_add: 'chemistApprovalRule/v2/add',

    // chemist survey approval rules
    survey_chemist_approve_list: 'surveyApprovalRule/listForCustomer',
    survey_chemist_approve_add: 'surveyApprovalRule/addForCustomer',
    survey_chemist_approve_edit: 'surveyApprovalRule/editForCustomer',

    // doctor approval rules
    doctor_approve_list: 'doctorApprovalRule/list',
    doctor_approve_details: 'doctorApprovalRule',
    doctor_approve_edit: 'doctorApprovalRule/edit',
    doctor_approve_add: 'doctorApprovalRule/add',
    doctor_approve_delete: 'doctorApprovalRule',

    // doctor survey approval rules
    survey_doctor_approve_list: 'surveyApprovalRule/listForDoctor',
    survey_doctor_approve_add: 'surveyApprovalRule/addForDoctor',
    survey_doctor_approve_edit: 'surveyApprovalRule/editForDoctor',

    // employee survey approval rules
    survey_team_approve_list: 'surveyApprovalRule/listForTeam',
    survey_team_approve_add: 'surveyApprovalRule/addForTeam',
    survey_team_approve_edit: 'surveyApprovalRule/editForTeam',

    // expense claim approval rules
    expenseclaim_approve_list: 'expenseClaimApprovalRule/list',
    expenseclaim_approve_add: 'expenseClaimApprovalRule/add',
    expenseclaim_approve_edit: 'expenseClaimApprovalRule/edit',
    expenseclaim_approve_delete: 'expenseClaimApprovalRule',
    expenseclaim_approve_details: 'expenseClaimApprovalRule',

    // market level
    market_level_details: 'marketLevel',
    market_level_add: 'marketLevel/add',
    market_level_edit: 'marketLevel/edit',
    market_level_delete: 'marketLevel',

    // order approval rules
    order_approve_list: 'orderApprovalRule/list',
    order_approve_edit: 'orderApprovalRule/edit',
    order_approve_add: 'orderApprovalRule/add',
    order_approve_details: 'orderApprovalRule',
    order_approve_delete: 'orderApprovalRule',

    // organization
    module_list: 'module/list',
    organization_modules: 'module/getListByOrganization',
    organization_list: 'organization/search',
    organization_list_login: 'organization/info/all',
    organization_details: 'organization',
    organization_add: 'organization/add',
    organization_edit: 'organization/edit',
    organization_delete: 'organization',
    organization_settings: 'organizationSettings/list',
    app_update: 'organization/updateAndroidAppInfo',
    environment_config: 'assets/config.json',
    generate_export_status: 'utility/export/status',

    // payment approval rules
    payment_approve_list: 'paymentApprovalRule/list',
    payment_approve_details: 'paymentApprovalRule',
    payment_approve_edit: 'paymentApprovalRule/edit',
    payment_approve_add: 'paymentApprovalRule/add',

    // site survey approval rules
    survey_site_approve_list: 'surveyApprovalRule/listForSite',
    survey_site_approve_add: 'surveyApprovalRule/addForSite',
    survey_site_approve_edit: 'surveyApprovalRule/editForSite',

    // ta da claim approval rules
    ta_da_approve_list: 'taDaClaimApprovalRule/list',
    ta_da_claim_approve_edit: 'taDaClaimApprovalRule/edit',
    ta_da_claim_approve_add: 'taDaClaimApprovalRule/add',

    // tour plan approval rules
    tourplan_approve_list: 'tourPlanApprovalRule/list',
    tourplan_approve_add: 'tourPlanApprovalRule/add',
    tourplan_approve_edit: 'tourPlanApprovalRule/edit',
    tourplan_approve_details: 'tourPlanApprovalRule',
    tourplan_approve_delete: 'tourPlanApprovalRule',

    // user leave approval rules
    userleave_approve_list: 'leaveApprovalRule/list',
    userleave_approve_add: 'leaveApprovalRule/add',
    userleave_approve_edit: 'leaveApprovalRule/edit',
    userleave_approve_details: 'leaveApprovalRule',
    userleave_approve_delete: 'leaveApprovalRule',

    // user roles approval rules
    user_role_list: 'userRole/list',
    subordinate_sales_role_list: 'userRole/subordinateSalesRoleList',
    user_role_details: 'userRole',
    user_role_add: 'userRole/add',
    user_role_edit: 'userRole/edit',
    user_role_modules: 'module/getListForUserRole',

    // visit approval rules
    visit_approve_list: 'visitApprovalRule/list',
    visit_approve_add: 'visitApprovalRule/add',
    visit_approve_edit: 'visitApprovalRule/edit',
    visit_approve_details: 'visitApprovalRule',
    visit_approve_delete: 'visitApprovalRule',

    /** Super Admin Ends */


    /** ************ Report Menu Starts ************** */

    /** Attendance Report Starts */

    daily_shift_wise_attendance_list: 'attendance/dayWiseAttendanceWithShift',
    export_daily_shift_wise_attendance_list: 'attendance/exportDayWiseAttendanceWithShift',
    market_attendance: 'attendance/marketPresenceCount',
    export_market_attendance: 'attendance/exportMarketPresenceCount',
    attendance_registry: 'attendance/registrar',
    export_attendance_registry: 'attendance/exportRegistrar',
    daily_status_registrar: 'attendance/dailyStatusRegistrar',
    export_daily_status_registrar: 'attendance/exportDailyStatusRegistrar',
    attendance_status_registrar: 'attendance/v2/statusRegistrar',
    attendance_status_registrar_export: 'attendance/v2/exportStatusRegistrar',
    userrole_wise_attendance_list: 'attendance/roleWisePerDayAttendanceCountReport',
    export_user_role_wise_attendance_list: 'attendance/exportRoleWisePerDayAttendanceCountReport',
    market_wise_attended_absent_count: 'attendance/marketWiseAttendedAbsentCount',
    absent_summary: 'attendance/absentSummary',
    role_wise_absent_count: 'attendance/roleWiseAbsentCount',
    attendance_user_list_shifting: 'attendance/userListWithShift',
    export_attendance_user_list_shifting: 'attendance/exportUserListWithShift',
    presence_report: 'attendance/presenceReport',
    presence_report_export: 'attendance/exportPresenceReport',
    present_absent_report: 'attendance/present-absent-report',
    present_absent_report_total_count: 'attendance/present-absent-report/total-count',
    export_present_absent_report: 'attendance/present-absent-report/export',
    attendance_registry_v2: 'api/attendance/registrar',
    export_attendance_registry_v2: 'api/attendance/registrar/export',

    /** Attendance Report Ends */


    /** Doctor Call Plan Report Starts */

    doctor_call_plan: 'doctorVisitPlan/doctorCallPlanReport',
    export_doctor_call_plan: 'doctorVisitPlan/exportDoctorCallPlan',
    doctor_product_call_plan: 'doctorVisitPlan/doctorProductCallPlan',
    export_doctor_product_call_plan: 'doctorVisitPlan/exportDoctorProductCallPlan',

    /** Doctor Call Plan Report Ends */

    /** Doctor Call Report Starts */

    user_dcr_calendar: 'doctorVisit/userDcrCalendar',
    export_user_calender_dcr_list: 'doctorVisit/exportUserDcrCalendar',

    user_brand_dcr_report: 'doctorVisit/userBrandDcrReport',

    doctor_wise_sample_gift_ppm_count: 'doctorVisit/doctorWiseSampleGiftPpmCount',
    export_doctor_wise_sample_gift_ppm_count: 'doctorVisit/exportDoctorWiseSampleGiftPpmCount',
    doctor_wise_sample_gift_ppm_count_v2: 'doctorVisit/v2/doctorWiseSampleGiftPpmCount',
    export_doctor_wise_sample_gift_ppm_count_v2: 'doctorVisit/v2/doctorWiseSampleGiftPpmCount/export',

    daily_user_dcr_report: 'doctorVisitPlan/userDailyDCRreport',
    daily_user_dcr_report_export: 'doctorVisitPlan/exportUserDailyDCRreport',

    doctor_dcr_calendar: 'doctorVisit/doctorDcrCalendar',
    export_doctor_calender_dcr_list: 'doctorVisit/exportDoctorDcrCalendar',
    doctor_dcr_list: 'api/doctor-visit-report/doctor-dcr-calendar',
    export_doctor_dcr_list: 'api/doctor-visit-report/doctor-dcr-calendar/export',

    doctor_market_dcr_report: 'doctorVisit/doctorMarketDcrReport',
    doctor_market_dcr_report_export: 'doctorVisit/exportDoctorMarketDcrReport',

    product_brand_dcr_calendar: 'doctorVisit/productBrandDcrCalendar',
    export_product_brand_calender_dcr_list: 'doctorVisit/exportProductBrandDcrCalendar',

    product_dcr_calendar: 'doctorVisit/productDcrCalendar',
    export_product_calender_dcr_list: 'doctorVisit/exportProductDcrCalendar',

    user_doctor_brand_report: 'doctorVisit/userDoctorBrandReport',
    export_user_doctor_brand_report: 'doctorVisit/exportUserDoctorBrandReport',

    market_product_doctor_dcr_report: 'doctorVisit/userDoctorProductReport',
    market_doctor_product_dcr_export: 'doctorVisit/exportUserDoctorProductReport',

    doctor_product_dcr_report: 'doctorVisit/summaryByDoctorProduct',
    export_doctor_product_dcr_report: 'doctorVisit/exportSummaryByDoctorProduct',

    dcr_comparison: 'doctorVisit/compareWithLastMonth',

    monthly_user_dcr_count: 'doctorVisit/userDcrMonthlyCount',

    market_product_dcr_report: 'doctorVisit/marketWiseDcrCountByProduct',
    export_market_product_dcr_report: 'doctorVisit/marketWiseDcrCountByProduct/export',

    market_product_distribution_report: 'doctorVisit/marketWiseProductDistributionThroughDcr',
    export_market_product_distribution_report: 'doctorVisit/marketWiseProductDistributionThroughDcr/export',

    accompany_call_report: 'doctorVisit/accompanyCallReport',
    export_accompany_call_report: 'doctorVisit/exportAccompanyCallReport',

    segment_wise_dcr_compact: 'doctorVisit/dcrCountByProductSegment/compact',
    export_segment_wise_dcr_compact: 'doctorVisit/dcrCountByProductSegment/compact/export',
    segment_wise_dcr_compact_total: 'doctorVisit/dcrCountByProductSegment/compact/total',
    segment_wise_dcr_calender: 'doctorVisit/dcrCountByProductSegment/calendar',
    export_segment_wise_dcr_calendar: 'doctorVisit/dcrCountByProductSegment/calendar/export',
    segment_wise_dcr_calender_total: 'doctorVisit/dcrCountByProductSegment/calendar/total',

    plan_vs_visit_for_one_user: 'doctorVisitPlan/planVsVisitOfOneUser',
    export_plan_vs_visit_for_one_user: 'doctorVisitPlan/exportPlanVsVisitOfOneUser',

    plan_vs_visit: 'doctorVisitPlan/planVsVisit',
    export_plan_vs_visit: 'doctorVisitPlan/exportPlanVsVisit',

    user_wise_plan_vs_visit_report: 'doctorVisitPlan/userWisePlanVsVisitReport',
    export_user_wise_plan_vs_visit_report: 'doctorVisitPlan/exportUserWisePlanVsVisitReport',
    user_product_rx: 'prescription/userAndProductWiseRxCount',
    export_user_product_rx: 'prescription/exportUserAndProductWiseRxCount',

    doctor_visit_count_by_user: 'doctorVisit/report/doctorVisitCountByUser',
    export_doctor_visit_count_by_user: 'doctorVisit/report/doctorVisitCountByUser/export',

    doctor_market_wise_visit_monitoring: 'doctorVisit/report/doctorMarketWiseVisitMonitoring',
    export_doctor_market_wise_visit_monitoring: 'doctorVisit/report/exportDoctorMarketWiseVisitMonitoring',

    doctor_wise_promoted_products: 'doctorVisit/report/doctor-wise-promoted-products',
    doctor_wise_promoted_products_export: 'doctorVisit/report/doctor-wise-promoted-products/export',
    user_wise_doctor_count_report: 'doctor/userWiseCount',
    export_user_wise_doctor_count_report: 'doctor/userWiseCount/export',

    /** Doctor Call Report Ends */


    /** Doctor Order Report Starts */

    doctor_order_market_sales_summary_report: 'doctorOrder/marketSummary',

    doctor_order_product_summary_report: 'doctorOrder/productSalesSummary',
    doctor_order_product_summary_export: 'doctorOrder/exportProductSalesSummary',

    doctor_order_brand_summary_report: 'doctorOrder/brandWiseSalesSummary',
    doctor_order_brand_summary_export: 'doctorOrder/exportBrandWiseSalesSummary',

    doctor_order_sales_summary_report: 'doctorOrder/summaryReport',
    doctor_order_sales_summary_export: 'doctorOrder/exportSummaryReport',

    /** Doctor Order Report Ends */

    /** Doctor Report Starts */

    doctor_coverage_market_list: 'doctor/coverageByMarket',
    export_doctor_coverage_market_list: 'doctor/exportCoverageByMarket',

    expected_product_vs_return_report: 'doctor/expectedProductVsReturn',
    export_expected_product_vs_return_report: 'doctor/expectedProductVsReturn/export',

    market_speciality_wise_count: 'doctor/marketSpecialityWiseCount',
    export_market_speciality_wise_count: 'doctor/exportMarketSpecialityWiseCount',

    rx_dcr_frequencies: 'api/doctor-report/rx-dcr-frequencies',
    rx_dcr_frequencies_export: 'api/doctor-report/rx-dcr-frequencies/export',

    /** Doctor Report Ends */


    /** Expense Claim Report Starts */

    monthly_expense_claim_list: 'expenseClaim/getMonthlyTaDaAndMileageOfUser',
    exportMonthlyTaDaAndMileageOfUser_list: 'expenseClaim/exportMonthlyTaDaAndMileageOfUser',
    expense_claim_per_user_report: 'expenseClaim/perUserReport',
    export_expense_claim_per_user_report: 'expenseClaim/exportPerUserReport',

    /** Expense Claim Report Ends */

    /** Order Report Starts */

    order_report_detail: 'order/detailedOrderReport',
    export_order_detail_report: 'order/exportDetailedOrderReport',

    order_report_chemist: 'order/orderSummaryByChemist',
    export_order_summary_chemist: 'order/exportOrderSummaryByChemist',

    order_report_product: 'order/orderSummaryByProduct',
    export_order_summary_product: 'order/exportOrderSummaryByProduct',

    ordered_quantity_report_for_user: 'order/orderedQuantityReport',
    ordered_quantity_report_export: 'order/exportOrderedQuantityReport',

    order_count_amount_by_user: 'orderReport/orderCountAndAmountByUser',
    export_order_count_amount_by_user: 'orderReport/exportOrderCountAndAmountByUser',

    /** Order Report Ends */

    /** Prescription Report Starts */

    user_rx_calendar: 'prescription/userRxCalendar',
    user_rx_calendar_summary: 'prescription/userRxCalendarSummary',

    user_rx_export: 'prescription/exportUserRxCalendar',
    export_user_calender_rx_list: 'prescription/exportUserRxCalendar',

    user_seen_rx: 'seenRx/userSeenRxCalendar',
    user_seen_rx_export: 'seenRx/exportUserSeenRxCalendar',

    user_rx_monthly_count: 'prescription/userRxMonthlyCount',
    user_rx_monthly_export: 'prescription/exportUserRxMonthlyCount',

    doctor_rx_monthly_count: 'prescription/doctorRxMonthlyCount',
    doctor_rx_monthly_export: 'prescription/exportDoctorRxMonthlyCount',

    doctor_rx_monthly_count_by_market: 'prescription/doctorRxMonthlyCountByMarket',
    export_doctor_rx_monthly_count_by_market: 'prescription/exportDoctorRxMonthlyCountByMarket',

    doctor_rx_calendar: 'prescription/doctorRxCalendar',
    export_doctor_calender_rx_list: 'prescription/exportDoctorRxCalendar',

    doctor_market_rx_count: 'prescription/doctorMarketRxReport',
    doctor_market_calender_rx_count: 'prescription/doctorMarketRxCalendar',
    doctor_market_calender_rx_count_export: 'prescription/doctorMarketRxCalendar/export',

    product_brand_rx_calendar: 'prescription/productBrandRxCalendar',
    export_product_brand_calender_rx_list: 'prescription/exportProductBrandRxCalendar',

    market_brand_rx_calendar: 'prescription/marketBrandRxCalendar',
    export_market_brand_rx_list: 'prescription/exportMarketBrandRxCalendar',

    market_product_rx: 'prescription/marketAndProductWiseRxCount',
    market_product_rx_export: 'prescription/marketAndProductWiseRxCount/export',

    user_brand_rx: 'prescription/userBrandRxReport',
    export_user_brand_rx_list: 'prescription/exportUserBrandRxReport',

    market_prescriber_calender: 'prescription/web/marketPrescriberCalendar',
    export_market_prescriber_calender: 'prescription/exportMarketPrescriberCalendar',

    institure_calender_rx: 'prescription/instituteRxCalendar',
    export_institure_calender_rx: 'prescription/exportInstituteRxCalendarReport',

    institure_brand_rx: 'prescription/instituteBrandRxCount',
    export_institure_brand_rx: 'prescription/exportInstituteBrandRxReport',

    doctor_brand_rx: 'prescription/doctorBrandRxReport',
    export_doctor_brand_rx_list: 'prescription/exportDoctorBrandRxReport',

    doctor_wise_rx_count_by_product: 'prescription/doctorWiseRxCountByProduct',
    doctor_wise_rx_count_by_product_compact: 'prescription/doctorWiseRxCountByProductCompact',
    export_doctor_wise_rx_count_by_product: 'prescription/exportDoctorWiseRxCountByProduct',
    export_doctor_wise_rx_count_by_product_compact: 'prescription/exportDoctorWiseRxCountByProductCompact',

    doctor_brand_wise_rx: 'prescription/doctorsBrandWiseRx',
    export_doctor_brand_wise_rx: 'prescription/exportDoctorsBrandWiseRx',

    product_rx_calendar: 'prescription/productRxCalendar',
    export_product_calender_rx_list: 'prescription/exportProductRxCalendar',

    market_rx_calender: 'prescription/web/marketRxCalendar',
    export_market_rx_report: 'prescription/exportMarketRxCalendar',

    market_rx_export: 'prescription/web/marketRxCalendar/export',
    market_rx_calendar_summary: 'prescription/marketRxCalendarSummary',

    user_rx_type_count: 'prescription/rxCountByUserAndRxType',
    user_rx_target_list: 'rxTarget/list',
    user_rx_target_add: 'rxTarget/add',
    user_rx_target_edit: 'rxTarget/edit',

    rx_comparison: 'prescription/compareWithLastMonth',

    monthly_market_rx_count: 'prescription/monthlyMarketRxCount',
    monthly_market_rx_count_summary: 'prescription/monthlyMarketRxCountSummary',
    monthly_market_rx_count_export: 'prescription/monthlyMarketRxCount/export',

    monthly_market_product_rx_count: 'prescription/monthlyMarketProductRxCount',
    monthly_market_product_rx_count_summary: 'prescription/monthlyMarketProductRxCountSummary',
    monthly_market_product_rx_count_export: 'prescription/monthlyMarketProductRxCount/export',

    rx_target_report_list: 'prescription/orion/rxTargetReport',
    export_rx_target_report_list: 'prescription/orion/exportRxTargetReport',

    market_wise_rx_share: 'rxSurvey/marketWiseRxShare',
    export_market_wise_rx_share: 'rxSurvey/marketWiseRxShare/export',
    market_wise_rx_share_summary: 'rxSurvey/marketWiseRxShareSummary',

    market_date_wise_rx_share_with_details: 'rxSurvey/marketDateWiseRxShareWithDetails',
    export_market_date_wise_rx_share_with_details: 'rxSurvey/exportMarketDateWiseRxShareWithDetails',
    market_date_wise_rx_share_with_details_summary: 'rxSurvey/marketDateWiseRxShareWithDetailsSummary',

    user_wise_rx_count_by_rx_type: 'prescription/userWiseRxCountByRxType',
    user_wise_rx_count_by_rx_type_summary: 'prescription/userWiseRxCountByRxType/summary',
    user_wise_rx_count_by_rx_type_export: 'prescription/userWiseRxCountByRxType/export',

    product_wise_rx_survey: 'rxSurvey/productWiseRxSurvey',
    export_product_wise_rx_survey: 'rxSurvey/exportProductWiseRxSurvey',
    product_wise_rx_survey_summary: 'rxSurvey/productWiseRxSurveySummary',

    doctor_wise_rx_survey: 'rxSurvey/doctorWiseRxSurvey',
    export_doctor_wise_rx_survey: 'rxSurvey/exportDoctorWiseRxSurvey',
    doctor_wise_rx_survey_summary: 'rxSurvey/doctorWiseRxSurveySummary',

    doctor_user_role_wise_rx_count: 'prescription/userRoleWiseRxCount',
    export_doctor_user_role_wise_rx_count: 'prescription/userRoleWiseRxCount/export',

    rx_productive_report: 'prescription/rx-productive-report',
    rx_productive_report_total: 'prescription/rx-productive-report/total-count',
    export_rx_productive_report: 'prescription/rx-productive-report/export',

    market_wise_rx_comparison_report: 'prescription/rx-comparison-report',
    market_wise_rx_comparison_report_total: 'prescription/rx-comparison-report/total',
    export_market_wise_rx_comparison_report: 'prescription/rx-comparison-report/export',

    /** Prescription Report Ends */

    /** Sample Stock Report Starts */

    sample_allocation_report: 'sampleStock/allocationOpeningClosingReport',
    export_sample_allocation_report: 'sampleStock/exportAllocationOpeningClosingReport',

    product_wise_sample_allocation_report: 'sampleStock/productWiseAllocationOpeningClosingReport',
    export_product_wise_sample_allocation_report: 'sampleStock/exportProductWiseAllocationOpeningClosingReport',

    sample_stock_allocation_summary: 'sampleStock/allocationSummary',
    sample_stock_allocation_export: 'sampleStock/exportAllocationSummary',

    sample_stock_summary: 'sampleStock/summary',
    sample_stock_summary_export: 'sampleStock/exportSummary',

    sample_allocation_usage_report: 'sampleStock/usageReport',

    /** Sample Stock Report Ends */

    /** User Report Starts */

    active_user_count_list: 'user/activeDayCount',
    active_user_count_export: 'user/exportActiveDayCount',

    mpo_performance_report: 'api/demo/mpo-performance',
    mpo_performance_detail: 'api/demo/mpo-performance/detail',

    /** User Report Ends */

    /** Due Report Starts */

    dms_invoice_and_due_by_user_report: 'api/v1/dueReport/invoice_and_due_by_user',
    dms_invoice_and_due_by_user_report_total: 'api/v1/dueReport/invoice_and_due_by_user/total',
    export_dms_invoice_and_due_by_user_report: 'api/v1/dueReport/invoice_and_due_by_user/export',

    dms_invoice_and_due_by_chemist_report: 'api/v1/dueReport/invoice_and_due_by_chemist',
    dms_invoice_and_due_by_chemist_report_total: 'api/v1/dueReport/invoice_and_due_by_chemist/total',
    export_dms_invoice_and_due_by_chemist_report: 'api/v1/dueReport/invoice_and_due_by_chemist/export',
    export_dms_chemist_wise_invoice_and_due_report_with_details: 'api/v1/dueReport/invoice_and_due_by_chemist/export/details',

    dms_chemist_sales_details: 'api/v1/dueReport/customer_sales_details',
    dms_chemist_sales_details_total: 'api/v1/dueReport/customer_sales_details/total',
    export_dms_chemist_sales_details: 'api/v1/dueReport/customer_sales_details/export',

    due_report_list: 'user/dueReport',
    due_report_export: 'user/exportDueReport',

    /** Due Report Ends */

    /** Sales Report Starts */

    product_wise_sales_summary: 'api/v1/sales_report/product_wise_sale_summary',
    product_wise_sales_summary_for_all_tab: 'api/v1/sales_report/product_wise_sale_summary-for-all-tab',
    product_wise_sales_summary_total: 'api/v1/sales_report/product_wise_sales_summary/total',
    product_wise_sales_summary_total_for_all_tab: 'api/v1/sales_report/product_wise_sales_summary-for-all-tab/total',
    export_product_wise_sales_summary: 'api/v1/sales_report/product_wise_sales_summary/export',
    export_product_wise_sales_summary_for_all_tab: 'api/v1/sales_report/product_wise_sales_summary-for-all-tab/export',
    party_wise_sales: 'api/v1/sales_report/party_wise_sales',
    party_wise_sales_total: 'api/v1/sales_report/party_wise_sales/total',
    export_party_wise_sales: 'api/v1/sales_report/party_wise_sales/export',
    party_wise_sales_pdf: 'api/v1/sales_report/party_wise_sales/pdf',

    users_product_wise_sales_quantity: 'api/v1/sales_report/users-product-wise-sales-quantity',
    users_product_wise_sales_quantity_export: 'api/v1/sales_report/users-product-wise-sales-quantity/export',
    sales_report_roles: 'api/v1/sales_report/role_for_filter',

    chemist_product_wise_sales_quantity: 'api/v1/sales_report/chemist-product-wise-sales-quantity',
    chemist_product_wise_sales_quantity_export: 'api/v1/sales_report/chemist-product-wise-sales-quantity/export',

    market_user_wise_sales: 'api/v1/sales_report/market_user_wise_sales',
    market_user_wise_sales_total: 'api/v1/sales_report/market_user_wise_sales/total',
    market_user_wise_sales_export: 'api/v1/sales_report/market_user_wise_sales/export',

    /** Sales Report Ends */

    /** Tour Plan Report Starts */

    // tour plan report
    tour_plan_user_wise_monthly_report: 'tourPlan/userWiseMonthlyReport',
    export_tour_plan_user_wise_monthly_report: 'tourPlan/exportUserWiseMonthlyReport',

    /** Tour Plan Report Ends */

    /** Chemist Ledger Report Starts */
    chemist_ledger_list: 'api/v1/chemist_ledger/list',
    /** Chemist Ledger Report Ends */

    /** User Ledger Report Starts */
    user_ledger_list: 'api/v1/user-ledger/list',
    /** User Ledger Report Ends */

    /** Depot Stock Transaction Report Starts */
    depot_stock_transaction_report: 'api/v1/depot-stock-transaction/list',
    all_depot_stock_report: 'api/v1/depot_stock/all-depot-stock',
    all_depot_stock_report_export: 'api/v1/depot_stock/all-depot-stock/export',
    all_depot_stock_report_total: 'api/v1/depot_stock/all-depot-stock/total',
    export_depot_stock_transaction_report: 'api/v1/depot-stock-transaction/list/export',
    create_depot_stock: 'api/v1/depot_stock/add',
    /** Depot Stock Transaction Report Ends */

    /** Depot Stock Movement Report Starts */
    depot_stock_movement_report: 'api/v1/depot_stock/movement-report',
    depot_stock_movement_report_export: 'api/v1/depot_stock/movement-report/export',
    /** Depot Stock Movement Report Ends */

    /** ************ Report Menu Ends ************** */

    /** Others */

    survey_approve_details: 'surveyApprovalRule',
    survey_approve_delete: 'surveyApprovalRule',

    survey_type_list: 'surveyType/list',
    survey_type_details: 'surveyType',
    survey_type_add: 'surveyType/add',
    survey_type_edit: 'surveyType/edit',

    survey_list: 'survey/list',
    survey_details: 'survey',
    survey_add: 'survey/add',
    survey_edit: 'survey/edit',

    survey_response_list: 'surveyRespondent/list',
    survey_response_approve: 'surveyRespondent/approve',

    survey_response_details: 'surveyRespondent',
    survey_response_add: 'surveyRespondent/add',
    survey_response_edit: 'surveyRespondent/edit',

    // invoice report
    sharif_sales_report_on_tp: 'invoice/sharif/salesReportOnTp',
    sharif_sales_report_on_tp_export: 'invoice/sharif/exportSalesReportOnTp',
    sharif_sales_report_on_tp_plus_vat: 'invoice/sharif/salesReportOnTpPlusVat',
    sharif_sales_report_on_tp_plus_vat_export: 'invoice/sharif/exportSalesReportOnTpPlusVat',
    sharif_sales_report_on_tp_compare: 'invoice/sharif/salesReportOnTpCompare',
    sharif_sales_report_on_tp_compare_export: 'invoice/sharif/exportSalesReportOnTpCompare',
    user_wise_product_sales: 'invoice/sharif/userProductWiseSales',
    user_wise_product_sales_metadata: 'invoice/sharif/userProductWiseSales/metadata',
    user_wise_product_sales_metadata_export: 'invoice/sharif/exportUserProductWiseSales',
    user_wise_product_sales_compare: 'invoice/sharif/userProductWiseSalesCompare',
    user_wise_product_sales_compare_export: 'invoice/sharif/exportUserProductWiseSalesCompare',
    product_and_market_level_wise_sales_summary: 'api/v1/sales_report/product_market_level_wise_sales_summary',
    product_and_market_level_wise_sales_summary_export: 'api/v1/sales_report/product_market_level_wise_sales_summary/export',
    product_and_market_level_wise_sales_summary_markets: 'api/v1/sales_report/product_market_level_wise_sales_summary/marketList',
    market_and_product_line_wise_sales_list: 'api/v1/sales_report/market-productline-wise-sales/list',
    market_and_product_line_wise_sales_product_line_list: 'api/v1/sales_report/market-productline-wise-sales/productLineList',
    market_and_product_line_wise_sales_total: 'pi/v1/sales_report/market-productline-wise-sales/total',
    market_and_product_line_wise_sales_list_export: 'api/v1/sales_report/market-productline-wise-sales/export',
    market_and_product_line_wise_sales_marketList: 'api/v1/sales_report/market-productline-wise-sales/marketList',


    // doctor service
    doctor_service_approval_rule_list: 'doctorServiceApprovalRule/list',
    doctor_service_approval_rule_add: 'doctorServiceApprovalRule/add',
    doctor_service_approval_rule_delete: 'doctorServiceApprovalRule',
    doctor_service_proposal_type_list: 'doctorServiceProposalType/list',
    doctor_service_proposal_type_add: 'doctorServiceProposalType/add',
    doctor_service_proposal_type_update: 'doctorServiceProposalType/edit',
    doctor_payment_method_list: 'doctorPaymentMethod/list',
    doctor_payment_method_add: 'doctorPaymentMethod/add',
    doctor_payment_method_update: 'doctorPaymentMethod/edit',

    doctor_service_proposal_list: 'doctorServiceProposal/list',
    doctor_service_proposal_detail: 'doctorServiceProposal/detail',
    doctor_service_status_change: 'doctorServiceProposal/approve',

    // patient
    patient_list: 'api/patients',
    patient_manage: 'api/patients',
    patient_details: 'api/patients',
    patient_search: 'api/patients/search',
    patient_rx_order_add: 'api/v1/rx/add',
    patient_rx_order_edit: 'api/v1/rx/edit',
    patient_rx_order_list: 'api/v1/rx/list',
    patient_rx_order_details: 'api/v1/rx/details',
    follow_up_patient: 'api/follow-ups/patient',
    top_chart_of_list: 'api/v1/rx/top-chart-of-list',
    running_out_of_drugs_patient_list: 'api/patient-product/get-patients-running-out-of-drugs',
    export_running_out_of_drugs_patient_list: 'api/patient-product/get-patients-running-out-of-drugs/export',
    patient_and_product_directory: 'api/patient-product/get-product-and-patient-directory',
    export_patient_and_product_directory: 'api/patient-product/get-product-and-patient-directory/export',
    invoice_bulk_upload_for_patient: 'api/v1/rx/upload',


    // patient dashboard
    patient_dashboard_summary: 'api/v1/rx/top-chart-of-list',
    depot_wise_patient_invoice_summary: 'api/v1/rx/dashboard/get-depot-wise-patient-invoice-summary',
    running_out_of_drugs_patients_number: 'api/patient-product/get-number-of-patients-running-out-of-drugs',

    // weekend
    monthly_weekend_request_list: 'api/weekendRequest/weekendRequestList',
    monthly_weekend_request_approve: 'api/weekendRequest/approve',
    weekend_request_edit: 'api/weekendRequest/editWeekendRequest',
    weekend_request_details: 'api/weekendRequest/getDetailsById',
    weekend_user_list: 'api/weekendRequest/weekendList',
    approved_weekend_date_of_user: 'api/weekendRequest/weekendListByUser',

    // geo market
    district_list: 'geo-market/district/list',
    district_add: 'geo-market/district/add',
    district_edit: 'geo-market/district/edit',
    change_district_status: 'geo-market/district/updateActiveStatus',

    thana_list: 'geo-market/thana/list',
    thana_add: 'geo-market/thana/add',
    thana_edit: 'geo-market/thana/edit',
    change_thana_status: 'geo-market/thana/updateActiveStatus',

    union_list: 'geo-market/union/list',
    union_add: 'geo-market/union/add',
    union_edit: 'geo-market/union/edit',
    change_union_status: 'geo-market/union/updateActiveStatus'
};
